import Abilities from "services/permissions/abilities";
import PermissionsConfig from "services/permissions/permissionsConfig";

/**
 * Dynamically extracts allowed output types from permissions configuration
 * @returns {string[]} Array of allowed output types (e.g., ["MAIL", "SMS"])
 */
export function getAllowedOutputTypes() {
  const alertsConfig = PermissionsConfig.alerts;
  const allowedTypes = [];

  Object.keys(alertsConfig).forEach((key) => {
    // Look for keys matching the pattern "configOutputs.{type}"
    const match = key.match(/^configOutputs\.(.+)$/);
    if (match && match[1]) {
      // Check if the user has the necessary permissions
      if (Abilities.ability.can("read", `alerts.${key}`)) {
        // Convert to uppercase to match the expected format
        allowedTypes.push(match[1].toUpperCase());
      }
    }
  });

  return allowedTypes;
}

export function filterValidPolicies(policies, allowedOutputTypes) {
  return policies.filter((policy) =>
    allowedOutputTypes.some((type) =>
      policy.outputs.map((output) => output.type).includes(type)
    )
  );
}

export function filterValidOutputs(outputs, allowedOutputTypes) {
  return outputs.filter((output) => allowedOutputTypes.includes(output.type));
}
